import axios from 'axios';
import { appInsights } from './AppInsights';
const apiClient = axios.create(); // No baseURL needed
// Request Trace
apiClient.interceptors.request.use((config) => {
 appInsights.trackTrace({
   message: 'API Request Sent',
   severityLevel: 0,
   properties: {
     method: config.method,
     url: config.url,
     data: JSON.stringify(config.data),
     headers: config.headers
   }
 });
 return config;
}, (error) => {
 appInsights.trackTrace({
   message: 'API Request Error',
   severityLevel: 3,
   properties: {
     error: error.message
   }
 });
 return Promise.reject(error);
});
// Response Trace
apiClient.interceptors.response.use((response) => {
 appInsights.trackTrace({
   message: 'API Response Received',
   severityLevel: 1,
   properties: {
     method: response.config.method,
     url: response.config.url,
     status: response.status,
     responseData: JSON.stringify(response.data)
   }
 });
 return response;
}, (error) => {
 appInsights.trackTrace({
   message: 'API Response Error',
   severityLevel: 3,
   properties: {
     method: error.config?.method,
     url: error.config?.url,
     status: error.response?.status,
     error: error.message
   }
 });
 return Promise.reject(error);
});
export default apiClient;